import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-card-container" }
const _hoisted_2 = { class: "step-card-header" }
const _hoisted_3 = { class: "title-container" }
const _hoisted_4 = ["title"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "content-card-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("button", {
        class: "edit-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.edit && _ctx.edit(...args))),
        title: _ctx.$t('app.button.edit')
      }, [
        _createElementVNode("img", {
          class: "edit-icon",
          src: _ctx.getEditIcon,
          alt: "",
          "aria-hidden": "true"
        }, null, 8, _hoisted_5)
      ], 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}